import React, {Component} from 'react';
import { NavLink } from "react-router-dom";
import MetaTags from 'react-meta-tags';

// Components
import Anime from '../../components/Anime/Anime';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';
import CallToAction from '../../containers/CallToAction/CallToAction';
import Hero from '../../containers/Hero/Hero';
import HeroLayer from '../../containers/Hero/HeroLayer';

class PageCustomization extends Component {

     render () {
         return (
            <div className="app-section">
                <MetaTags>
                    <title>Customization Service</title>
                    <meta 
                        name="description" 
                        content="Need some custom work done for your theme? Rascals Themes now offering Customization Service that will make your dream site come true." 
                    />
                </MetaTags>

                <Hero height="auto" classes="hero-page">
                	<div className="container">
		            	<ContentHeader 
                            title="Customization Service" 
                            subTitle="Need some custom work done for your theme? Rascals Themes now offering Customization Service that will make your dream site come true." 
                            classes="" 
                        />
	                </div>
		            <HeroLayer
	                	classes="lines-bg anim anim--fade anim--duration-4 anim--delay-3"
	                	styleOuter={{
	                		zIndex:1
	                	}}
	                	styleInner={{
	                		top: 0,
	                		bottom: 0,
	                		left:0,
	                		right:0,
	                		opacity:0.6,
                    		backgroundSize: "cover",
	                		backgroundImage: "url(https://rascalsthemes.com/images/dark-texture.jpg)",
	                	}}
	                />
            	</Hero>

                <div className="customization-service">
                    <div className="container">
                        <div className="row row-large-gutter row-padding">

                            <div className="col-xl-6 col-12 pb customization-column">
                            	<Anime type="fade-up" delay="3" duration="3">
                                	<h3>Theme customization</h3>
                                </Anime>
                                <Anime type="fade-up" delay="4" duration="3">
	                                <p>
	                                    Customization can be any work you need done to the theme that is not covered by the <NavLink to="/support-policy">scope of our support policy</NavLink>. In most cases, this is anything that falls outside of the options the theme offers. The goal is to achieve the greatest results without spending too much time. We help customize a WordPress theme to your business or organisation’s needs.
	                                </p>
	                                
	                                <h3>WordPress Installation</h3>
	                                <p>Installation Of WordPress in right manner is essential and we can get it done on any hosting of your choice.</p>

	                                <h3>Theme Setup & Configuration</h3>
	                                <p>Our team will take care of WordPress theme upload, setup and customization upon your requirements.</p>
	                         
	                                <h3>Integrate music player</h3>
	                                <p>Integration our music player with your theme. We have two powerful music players that may also appear on your site!</p>

	                                <h3>Plugin Integration</h3>
	                                <p>We will choose the right plugins for your website and will install and configure them according to your need.</p>

	                                <h3>Other WordPress Customization Services</h3>
	                                <ul className="check-list">
	                                    <li>
	                                        Custom Contact Forms;
	                                    </li>
	                                    <li>
	                                        Moving to a new Hosting Account;
	                                    </li>
	                                    <li> 
	                                        Installing home page Sliders
	                                    </li>
	                                    <li>
	                                        Expanding your Footer;
	                                    </li>
	                                    <li>
	                                        Expanding your Header;
	                                    </li>
	                                </ul>
	                            </Anime>
                            </div>
                        </div>
                    </div>
                </div>
                <CallToAction 
                    buttonTitle="Get a Free Quote"
                    buttonLink="/contact"
                    text="You need professional customization for your theme?"
                    classes="cta--full cta--color cta--center"
                />
            </div>

        );
    }
}

export default PageCustomization;


// WEBPACK FOOTER //
// ./src/pages/PageCustomization/PageCustomization.js